import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export interface BonusItem {
  title: string;
  image: string;
  content: React.ReactNode;
}
function BonusCard({
  bonus,
  isOpen,
  onClick
}: {
  bonus: BonusItem;
  isOpen: boolean;
  onClick: () => void;
}) {
  return <div className="rounded-2xl overflow-hidden bg-white border border-green-100 shadow-sm" data-id="element-10">
      {/* Preview image with gradient fade */}
      <div className="relative h-40 w-full overflow-hidden" data-id="element-11">
        <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover object-top" data-id="element-12" />
        {/* gradient fade to white at the bottom so it blends into the title */}
        <div className="absolute inset-0 bg-gradient-to-t from-white via-white/40 to-transparent" data-id="element-13" />
        <span className="absolute top-3 left-3 bg-green-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow" data-id="element-14">
          GRATIS HOY
        </span>
      </div>

      <button onClick={onClick} className="w-full flex justify-between items-center gap-3 px-5 py-4 text-left hover:bg-green-50 transition-colors" data-id="element-15">
        <h3 className="text-base md:text-lg font-bold text-green-800" data-id="element-16">
          {bonus.title}
        </h3>
        <ChevronDown className={`w-5 h-5 text-green-600 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-17" />
      </button>

      <AnimatePresence initial={false} data-id="element-18">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-19">
            <div className="px-5 pb-5 pt-0 text-gray-600 border-t border-green-50" data-id="element-20">
              {bonus.content}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function BonusAccordion({
  bonuses
}: {
  bonuses: BonusItem[];
}) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-21">
      {bonuses.map((bonus, idx) => <BonusCard key={idx} bonus={bonus} isOpen={openIndex === idx} onClick={() => setOpenIndex(openIndex === idx ? null : idx)} data-id="element-22" />)}
    </div>;
}